import * as React from "react";
import { entity } from "src/infra/api/rpc/api";
import { stars } from "src/presentation/component/client/customer/stars";
import styled from "styled-components";

interface IProps {
  reviews: entity.IReview[];
}

export const ReviewList: React.FC<IProps> = (props) => {
  const { reviews } = props;

  const [ellipsis, setEllipsis] = React.useState<boolean>(reviews.length > 1);

  return (
    <React.Fragment>
      <div>
        {(ellipsis ? reviews.slice(0, 1) : reviews).map((review) => {
          return (
            <div key={review.id!} style={{ marginBottom: 40 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <p
                    style={{
                      color: "#a4a4a4",
                      fontSize: 15,
                      fontWeight: "bold",
                      lineHeight: "24px",
                    }}
                  >
                    {review.companyName} | {review.companyPosition}
                  </p>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 15,
                      fontWeight: "bold",
                      lineHeight: "24px",
                    }}
                  >
                    {review.title}
                  </p>
                </div>
                {stars(review.point!)}
              </div>

              <div
                style={{
                  marginTop: 16,
                  padding: "36px 45px",
                  borderRadius: 5,
                  background: "#f1f6f8",
                  whiteSpace: "pre-wrap",
                }}
              >
                {review.text}
              </div>
            </div>
          );
        })}

        {ellipsis && (
          <ReadMore
            onClick={() => {
              setEllipsis(false);
            }}
          >
            全て表示
          </ReadMore>
        )}
      </div>
    </React.Fragment>
  );
};

export default ReviewList;

const ReadMore = styled.div`
  width: 130px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin: 18px auto;
  background-color: #eeeeee;
  border-radius: 30px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/customer/review_list.tsx